export default __webpack_public_path__ + "static/media/apps_openapi.9d86389a.yaml";